// LogsTab.jsx - 操作日志Tab组件
import React from 'react';
import { Table, Tag } from 'antd';
import { useTranslation } from 'react-i18next';

const COLORS = { primary: '#00d4ff', text: '#ffffff', muted: 'rgba(255,255,255,0.6)', solar: '#f4c542', storage: '#52e8b0', load: '#ff5a7f', grid: '#3a8dde' };

const fmtTime = (t) => t ? new Date(t).toLocaleString() : '-';

const resultColor = { acked: 'green', accepted: 'blue', rejected: 'red', failed: 'red', timeout: 'orange' };
const resultText = { acked: '已应答', accepted: '已接受', rejected: '已拒绝', failed: '失败', timeout: '超时' };

const LogsTab = ({ controlLogs, loading, pageSize }) => {
  const { t } = useTranslation();

  return (
    <div style={{ padding: '16px' }}>
      <Table
      columns={[
        { title: 'sn', dataIndex: 'sn', key: 'sn', render: t => <span style={{ color: COLORS.primary }}>{t || '-'}</span>, width: 130 },
        { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.stationName')}</span>, dataIndex: 'station_name', key: 'station_name', render: t => t || '-', width: 130 },
        { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.operator')}</span>, dataIndex: 'username', key: 'username', render: t => <span style={{ color: COLORS.primary }}>{t || '-'}</span> },
        { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.operationType')}</span>, dataIndex: 'operation', key: 'operation', render: t => <Tag color={t === 'schedule' ? 'purple' : 'blue'}>{t}</Tag> },
        { title: <span style={{whiteSpace:'nowrap'}}>source</span>, dataIndex: 'source', key: 'source', render: t => t || '-', width: 90 },
        { title: <span style={{whiteSpace:'nowrap'}}>request_id</span>, dataIndex: 'request_id', key: 'request_id', render: t => <span style={{ color: COLORS.muted, fontSize: 11 }}>{t}</span>, width: 180 },
        { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.executeResult')}</span>, dataIndex: 'result', key: 'result', render: v => <Tag color={resultColor[v] || 'default'}>{resultText[v] || v}</Tag>, width: 90 },
        { title: <span style={{whiteSpace:'nowrap'}}>error_code</span>, dataIndex: 'error_code', key: 'error_code', render: t => <span style={{ color: t && t !== 'OK' ? COLORS.load : COLORS.storage }}>{t || '-'}</span>, width: 120 },
        { title: <span style={{whiteSpace:'nowrap'}}>message</span>, dataIndex: 'message', key: 'message', render: t => t || '-', width: 200 },
        { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.additionalParams')}</span>, dataIndex: 'detail', key: 'detail', render: t => typeof t === 'string' ? t : (t ? JSON.stringify(t) : '-'), width: 200 },
        { title: <span style={{whiteSpace:'nowrap'}}>{t('cloud.executeTime')}</span>, dataIndex: 'executed_at', key: 'executed_at', render: fmtTime },
      ]}
      dataSource={controlLogs}
      loading={loading}
      rowKey="id"
      pagination={{ pageSize, showSizeChanger: false }}
      style={{ background: 'transparent' }}
      scroll={{ x: 1800 }}
      tableLayout="fixed" />
    </div>
  );
};

export default LogsTab;
